
import { UseDatasetListA, UseMapservice } from './vallaris'
import {
  UseVoListA,
  UseStorageListA,
  UseCallbackStorageListA,
  UseStorageFieldsA,
  UseCallbackStorageFieldsA,
  UseLastObjectsA,
  UseCallbackLastObjectA
} from './jetstream'

export const useDatasetListA = UseDatasetListA
export const useMapserviceA = UseMapservice

export const useVoListA = UseVoListA
export const useStorageListA = UseStorageListA
export const useCallbackStorageListA = UseCallbackStorageListA
export const useStorageFieldsA = UseStorageFieldsA
export const useCallbackStorageFieldsA = UseCallbackStorageFieldsA
export const useLastObjectsA = UseLastObjectsA
export const useCallbackLastObjectA = UseCallbackLastObjectA
